export const isTopIndustry = (index: number) => index === 0;
export const isSecondTopIndustry = (index: number) => index === 1;
export const isThirdTopIndustry = (index: number) => index === 2;
